import React, { Component } from "react"

import Header from '../../components/Header/Header';
import Content_Tarjetas from "./Content_Tarjetas";
import Footer from '../../components/Footer/Footer';

class Tarjetas extends Component {
    render() {
        return (

            <div class="main-container">
                <Header />
                <Content_Tarjetas />
                <Footer />
            </div>

        )
    }
}

export default Tarjetas;